import { Component, inject, Input, OnInit } from '@angular/core';
import { ManagedContentItem } from '@app/common-models/managed-content-item';
import { ContentMessagingCardComponent } from '@app/component/content-messaging-card/content-messaging-card.component';
import { ManagedContentAppService } from '@app/service/managed-content-app.service';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

/**
 * Component representing page not found Api call
 * NOTE: This page is currently being used for AppInit failures in a "stripped down" mode.
 * We should ask UI/UX for guidance on how this should look.
 * @Component
 */
@Component({
  standalone: true,
  selector: 'cu-generic-error',
  templateUrl: './generic_error.component.html',
  imports: [ContentMessagingCardComponent, SharedUiLibraryModule]
})
/**
 * Class representing generic error page
 * @export
 * @class GenericErrorComponent
 */
export class GenericErrorComponent implements OnInit {
  private readonly contentAppService = inject(ManagedContentAppService);
  @Input()
  public pageContent?: ManagedContentItem;

  public ngOnInit(): void {
    if (!this.pageContent) {
      this.contentAppService.getManagedContentForPage('Error').subscribe((data) => {
        this.pageContent = data || ({} as unknown as ManagedContentItem);
      });
    }
  }
}
